import React from 'react';
import { Col } from 'antd';
import { useNavigate } from 'react-router';

// assets
import successCheckboxIcon from 'assets/icons/successCheckboxIcon.svg';

// components
import { TextComponent } from 'baseComponents/TextComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { ScreenWrapperComponent } from 'components/layouts/ScreenWrapperComponent';

// styles
import 'components/SuccessScreen/successScreen.scss';

interface Props {
  pageTitle?: string;
  successTitle: string;
  successSubtitle: string;
  buttonLabel: string;
}

export const SuccessScreen: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  return (
    <ScreenWrapperComponent>
      <Col
        lg={{ pull: 8, push: 8, span: 8 }}
        md={{ pull: 6, push: 6, span: 12 }}
      >
        {props.pageTitle && (
          <div className='success-screen-title'>
            <TextComponent
              size='table-title-size'
              text={props.pageTitle}
              center
            />
          </div>
        )}
        <div className='success-screen-content-wrapper'>
          <>
            <div className='status-box'>
              <img src={successCheckboxIcon} alt='Green checkbox icon' />
              <div className='status-text-wrapper'>
                <TextComponent
                  text={props.successTitle}
                  styleType='success'
                  weight='extra-bold'
                />
                <TextComponent
                  text={props.successSubtitle}
                  weight='extra-light'
                />
              </div>
            </div>
            <Col
              lg={{ pull: 3, push: 3, span: 18 }}
              md={{ pull: 1, push: 1, span: 22 }}
            >
              <ButtonComponent
                label={props.buttonLabel}
                size='middle'
                appereance='primary'
                fullWidth
                onClick={() => navigate('/home')}
              />
            </Col>
          </>
        </div>
      </Col>
    </ScreenWrapperComponent>
  );
};
